import { requestBuilder } from '../../http/RequestBuilder';

export interface CreditProfileResponse {
    success: boolean;
    data?: {
        name?: string;
        dateOfBirth?: string;
        address?: {
            street?: string;
            city?: string;
            state?: string;
        };
        // TODO: Add actual response structure from SpinwheelResponseDto
    };
}

export const useGetCreditProfile = requestBuilder.query<CreditProfileResponse>({
    endpoint: '/api/spinwheel/credit-profile',
    queryKey: 'getCreditProfile',
});
